/**
 * Flags de funcionalidades aún no publicadas. Se ocultan en la UI hasta estar listas.
 * Activar con la variable de build correspondiente (default: oculto).
 */

// "Continuar con Google" en login/registro: oculto hasta que el flujo OAuth esté funcional.
export const GOOGLE_SIGNIN_ENABLED = process.env.REACT_APP_GOOGLE_SIGNIN === 'true';

// Integración Zoom (asistencia automática): oculta hasta tener las credenciales S2S del dueño de
// la cuenta. Se enciende con REACT_APP_ZOOM_ENABLED=true (front) + ZOOM_ATTENDANCE_ENABLED=true (back).
export const ZOOM_ENABLED = process.env.REACT_APP_ZOOM_ENABLED === 'true';

export default { GOOGLE_SIGNIN_ENABLED, ZOOM_ENABLED };
